<template>
  <div>
    <el-dialog
      title="智能客服"
      :visible.sync="code"
      width="20%"
      @close="close"
      height="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="form" ref="form">
        <el-col :span="6">
          <el-form-item prop="first">
            <el-input
              ref="first"
              maxlength="1"
              v-focus
              v-model="form.first"
              autocomplete="off"
              style="width: 50px"
              @input="firstInput"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="second">
            <el-input
              ref="second"
              maxlength="1"
              v-model="form.second"
              autocomplete="off"
              style="width: 50px"
              @input="secondInput"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="third">
            <el-input
              ref="third"
              maxlength="1"
              v-model="form.third"
              autocomplete="off"
              style="width: 50px"
              @input="thirdInput"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="fifth">
            <el-input
              ref="fifth"
              maxlength="1"
              v-model="form.fifth"
              autocomplete="off"
              style="width: 50px"
              @input="fifthInput"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div v-if="tishi" class="err">{{ errMsg }}</div>
        <el-button
          @click="ReSend"
          :disabled="resendDis"
          type="text"
          style="width: 100%; margin-top: 10px"
        >
          {{ buttonName }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  name: "MessageCode",
  props: [
    "password",
    "loginType",
    "username",
    "equNo",
    "station",
    "remember",
    "version",
    "addStation",
  ],
  data() {
    return {
      code: true,
      tishi: false,
      errMsg: "",
      SMScode: "",
      psd: "",
      form: {
        first: "",
        second: "",
        third: "",
        fifth: "",
      },
      resendDis: true,
      buttonName: "重新发送验证码",
      time: 60,
    };
  },
  components: {},
  directives: {
    focus: {
      inserted: function (e1) {
        e1.children[0].focus();
      },
    },
  },
  beforeDestroy() {
    document.onkeydown = undefined;
  },
  mounted() {
    console.log("addStation:", this.addStation);
    let self = this;
    self.intervalFun();
    document.onkeydown = function (e) {
      let ev = document.all ? window.event : e;
      var code = self.SMScode;
      if (ev.keyCode === 8 && code.length == 4) {
        console.log(code.length);
        self.$refs.fifth.focus();
      } else if (ev.keyCode === 8 && code.length == 3) {
        console.log(code.length);
        self.$refs.third.focus();
      } else if (ev.keyCode === 8 && code.length == 2) {
        console.log(code.length);
        self.$refs.second.focus();
      } else if (ev.keyCode === 8 && code.length == 1) {
        console.log(code.length);
        self.$refs.first.focus();
      } else if (ev.keyCode === 8 && code.length == 0) {
        console.log(code.length);
        self.$refs.first.focus();
      }
    };
  },
  methods: {
    ReSend() {
      let that = this;
      that.resendDis = true;
      that.intervalFun();
      that.$emit("ReSend", "");
    },
    close() {
      // console.log(5555555555)
      this.$emit("close", "");
    },
    firstInput(value) {
      if (!/\d{1}/.test(value)) {
        this.form.first = "";
        this.$refs.first.focus();
      } else if (/\d{1}/.test(value)) {
        this.form.first = value;
        this.$refs.second.focus();
      }
      this.SMScode =
        this.form.first + this.form.second + this.form.third + this.form.fifth;
      console.log("验证码长度", this.SMScode.length);
    },
    secondInput(value) {
      if (!/\d{1}/.test(value)) {
        this.form.second = "";
        this.$refs.second.focus();
      } else if (/\d{1}/.test(value)) {
        this.form.second = value;
        this.$refs.third.focus();
      }
      this.SMScode =
        this.form.first + this.form.second + this.form.third + this.form.fifth;
      console.log("验证码长度", this.SMScode.length);
    },
    thirdInput(value) {
      if (!/\d{1}/.test(value)) {
        this.form.third = "";
        this.$refs.third.focus();
      } else if (/\d{1}/.test(value)) {
        this.form.third = value;
        this.$refs.fifth.focus();
      }
      this.SMScode =
        this.form.first + this.form.second + this.form.third + this.form.fifth;
      console.log("验证码长度", this.SMScode.length);
    },
    async fifthInput(value) {
      this.SMScode =
        this.form.first + this.form.second + this.form.third + this.form.fifth;
      if (
        /\d{1}/.test(value) &&
        this.form.first != "" &&
        this.form.second != "" &&
        this.form.third != ""
      ) {
        const site = this.util.getLocalSite();
        var loginApi = "/manager/user/pass/login";
        console.log("equNo=================", this.equNo);
        const response = await this.util.postRequest({
          url: loginApi,
          method: "POST",
          data: {
            loginName: this.username,
            // 记住密码回填已是 md5，special 时不可再加密
            password:
              this.loginType === "special"
                ? this.password
                : md5(this.password),
            captcha: this.SMScode,
            // isLogFree: this.isFree,
            webId: site.webId,
            equNo: this.equNo,
            version: this.version,
            passwordFlag: this.remember,
          },
        });
        console.log("messageCodeBox input response = ", response);
        if (response.resultCode === "10000") {
          var account = response.data.bearUser;
          console.log("messageBox id = ", account.id);

          var token = response.data.token;
          localStorage.setItem("token", token);
          localStorage.setItem("account", JSON.stringify(account));
          this.addStation(1);
          // localStorage.setItem("webId" , site.webId)
          // localStorage.setItem("loginName",this.username)

          this.tishi = false;
          this.$emit("successed", "");

          this.util.setLoginTip(1);
          this.getAuthorityRequest();
        } else if (response.resultCode === "30001") {
          this.$message.error(response.desc);
        } else {
          this.tishi = true;
          // console.log("验证码不正确")
          this.errMsg = response.desc;
        }
      } else if (value != "") {
        this.tishi = true;
        this.errMsg = "请输入正确格式的验证码";
      } else {
        console.log("四号验证码空了");
      }
    },

    intervalFun() {
      let that = this;
      that.resendDis = true;
      let interval = window.setInterval(function () {
        that.buttonName = that.time + "秒后重新发送";
        --that.time;
        if (that.time < 0) {
          that.buttonName = "重新发送验证码";
          that.time = 60;
          that.resendDis = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    setDefaultSetting() {
      console.log("msgCodeBox setDefaultSetting");
      var tempObj = {};
      tempObj.endChat = false;
      tempObj.disturb = false;
      tempObj.transter = false;
      tempObj.markTag = false;
      tempObj.defriend = false;
      tempObj.adapter = false;
      tempObj.colleage = false;
      tempObj.trouble = false;
      tempObj.personPmtList = [];
      tempObj.systemPmtList = [];
      tempObj.midmanPmtList = [];
      tempObj.loginmgList = [];
      tempObj.log = false;
      tempObj.word = false;
      tempObj.record = false;
      tempObj.bot = false;
      tempObj.transterTa = false;
      tempObj.downHtml = false;
      tempObj.isOnlineList = false;
      tempObj.isOnlineOffList = false;
      this.util.setLocalPermit(JSON.stringify(tempObj));
      //this.$store.state.authority.isColleague = false;
    },

    async getAuthorityRequest() {
      console.log("msgCodeBox getAuthorityRequest");
      var api = "/manager/permission/getPermissionList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("msgCodeBox getAuthorityRequest response = ", response);
      if (response.resultCode === "10000") {
        this.setDefaultSetting();
        var tempObj = this.util.getLocalPermintObj();
        for (var i = 0; i < response.data.length; i++) {
          const chatPermi = response.data[i];
          if (chatPermi.name === "对话管理") {
            const permiList = chatPermi.permiVoList;
            for (var j = 0; j < permiList.length; j++) {
              var permit = permiList[j];
              if (permit.name === "关闭会话") {
                tempObj.endChat = permit.status == 1 ? true : false;
              } else if (permit.name === "勿扰设置") {
                tempObj.disturb = permit.status == 1 ? true : false;
              } else if (permit.name === "转接会话") {
                tempObj.transter = permit.status == 1 ? true : false;
              } else if (permit.name === "打标签") {
                tempObj.markTag = permit.status == 1 ? true : false;
              } else if (permit.name === "添加黑名单") {
                tempObj.defriend = permit.status == 1 ? true : false;
              } else if (permit.name === "接管会话") {
                tempObj.adapter = permit.status == 1 ? true : false;
              } else if (permit.name === "我的同事") {
                tempObj.colleage = permit.status == 1 ? true : false;
              } else if (permit.name === "疑似骚扰用户") {
                tempObj.trouble = permit.status == 1 ? true : false;
              } else if (permit.name === "转接给他人") {
                tempObj.transterTa = permit.status == 1 ? true : false;
              } else if (permit.name == "在线访客列表") {
                tempObj.isOnlineList = permit.status == 1 ? true : false;
              } else if (permit.name == "同事快捷回复展现") {
                tempObj.quickShow = permit.status == 1 ? true : false;
              } else if (permit.name == "公共快捷回复展现") {
                tempObj.publicQuickShow = permit.status == 1 ? true : false;
              } else if (permit.name == "已离开（未结束）列表") {
                tempObj.isOnlineOffList = permit.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "个人设置") {
            tempObj.personPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "系统设置") {
            tempObj.systemPmtList = this.util.normalizeSystemPmtList(
              chatPermi.permiVoList
            );
          } else if (chatPermi.name === "日志管理") {
            tempObj.log = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "留言管理") {
            tempObj.word = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "对话记录") {
            tempObj.record = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "开口机器人") {
            tempObj.bot = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "报表管理") {
            const permiList = chatPermi.permiVoList;
            for (var o = 0; o < permiList.length; o++) {
              var permit1 = permiList[o];
              if (permit1.name === "HTML报表下载") {
                tempObj.downHtml = permit1.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "Middleman管理") {
            tempObj.midmanPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "登录管理") {
            tempObj.loginmgList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          }
        }

        this.util.setLocalPermit(JSON.stringify(tempObj));
        console.log(
          "this.util.getLocalPermintObj()",
          this.util.getLocalPermintObj()
        );
        this.$store.state.authority.isShowLog = this.util.getLocalPermit("log");
        this.$store.state.authority.isShowWord =
          this.util.getLocalPermit("word");
        this.$store.state.authority.isColleague =
          this.util.getLocalPermit("colleage");
        this.$store.state.authority.isTrouble =
          this.util.getLocalPermit("trouble");
        this.$store.state.authority.isEndChat =
          this.util.getLocalPermit("endChat");
        this.$store.state.authority.isTransfer =
          this.util.getLocalPermit("transter");
        this.$store.state.authority.isDefriend =
          this.util.getLocalPermit("defriend");
        this.$store.state.authority.isAdapter =
          this.util.getLocalPermit("adapter");
        this.$store.state.authority.isDisturb =
          this.util.getLocalPermit("disturb");
        this.$store.state.authority.isMarkTag =
          this.util.getLocalPermit("markTag");
        this.$store.state.authority.isQuickShow =
        this.util.getLocalPermit("quickShow");
        this.$store.state.authority.isPublicQuickShow =
        this.util.getLocalPermit("publicQuickShow");
          
        this.$store.state.authority.isShowBot = this.util.getLocalPermit("bot");
        this.$store.state.authority.isShowRecord =
          this.util.getLocalPermit("record");
        this.$store.state.authority.isOnlineList =
          this.util.getLocalPermit("isOnlineList");
          this.$store.state.authority.isOnlineOffList =
          this.util.getLocalPermit("isOnlineOffList");
        this.$store.state.authority.isTransferTa =
          this.util.getLocalPermit("transterTa");
        this.$store.state.authority.isDownHtml =
          this.util.getLocalPermit("downHtml");
        this.$store.state.authority.personList =
          this.util.getLocalPermit("personPmtList");
        this.$store.state.authority.systemList =
          this.util.getLocalPermit("systemPmtList");
        this.$store.state.authority.midmanList =
          this.util.getLocalPermit("midmanPmtList");

        this.$store.state.authority.loginmg =
          this.util.getLocalPermit("loginmgList");
      } else {
        this.$message.error(response.desc);
      }
    },
  },
};
</script>

<style>
.err {
  width: 100%;
  color: red;
  line-height: 30px;
  text-align: center;
}
</style>
